/**
 * Una tabla de la pantalla, bajada como CSV.
 *
 * Lo que ya está en pantalla no hace falta volver a pedírselo al servidor: se
 * arma aquí. Con punto y coma y la marca de UTF-8 delante porque es lo que el
 * Excel de un equipo en español abre en columnas y con las tildes bien; con
 * coma lo abre todo en una sola celda.
 */
export function aCsv(cabecera: string[], filas: (string | number | null)[][]): string {
  const celda = (valor: string | number | null) => {
    const texto = valor === null ? '' : String(valor);
    return /[";\n\r]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
  };

  return [cabecera, ...filas].map((fila) => fila.map(celda).join(';')).join('\r\n');
}

export function descargarCsv(nombre: string, cabecera: string[], filas: (string | number | null)[][]): void {
  const archivo = new Blob(['﻿', aCsv(cabecera, filas)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(archivo);
  const enlace = document.createElement('a');

  enlace.href = url;
  enlace.download = nombre;
  document.body.append(enlace);
  enlace.click();
  enlace.remove();
  URL.revokeObjectURL(url);
}
